import React, { useState, useEffect } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { EDIT_ROLE, CLONE_ROLE, CREATE_ROLE } from 'constants/drawerTitles';

import { ToggleRow } from '../ToggleRow';

const ToggleForm = ({ onToggleFormChange, parent, toggles, drawerTitle }) => {
  const [toggleValues, setToggleValues] = useState(toggles);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (parent) setDisabled(false);
    if (!parent) {
      setDisabled(true);
      const togglesOff = toggles.map((t) => {
        const toggle = Object.keys(t);

        return { [toggle]: false };
      });

      setToggleValues(togglesOff);
    }
    setToggleValues(toggles);
    if (
      drawerTitle !== EDIT_ROLE &&
      drawerTitle !== CLONE_ROLE &&
      drawerTitle !== CREATE_ROLE
    ) {
      setDisabled(true);
    }
  }, [parent, toggles]);

  const onToggleRowChange = (value) => {
    const [vKey] = Object.keys(value);
    const togglesValues = toggles.map((toggle) => {
      const [tKey] = Object.keys(toggle);

      if (tKey === vKey) {
        return { [tKey]: Object.values(value)[0] };
      }

      return toggle;
    });

    setToggleValues(togglesValues);
    onToggleFormChange(togglesValues);
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      {toggleValues.map((toggle, i) => {
        const [name] = Object.keys(toggle);

        return (
          <ToggleRow
            onToggleRowChange={onToggleRowChange}
            key={i}
            name={name}
            value={toggle[name]}
            disabled={disabled}
          />
        );
      })}
    </Grid>
  );
};

export default ToggleForm;
